/* eslint-disable prefer-arrow/prefer-arrow-functions */
import {
  IAggregate,
  IAggregateWithMetric,
  IComputedAggregate,
} from '../../types';

/**
 * @description A concatenated string of test type id and metric id seperated by an underscore
 */
export type MetricMaskKey = `${string}_${string}`;

/**
 * @description Returns a new aggregate with only the metrics specified in the mask
 * The mask is an array of strings where each string is a concatenated string of test type id and metric id seperated by an underscore
 * @param aggregate
 * @param mask
 * @returns
 */
export function metricMask(
  aggregate: IComputedAggregate,
  mask: MetricMaskKey[]
): IComputedAggregate {
  return {
    meta: aggregate.meta,
    data: mask.reduce(
      (
        acc: { [key: string]: IAggregateWithMetric | IAggregate },
        maskKey: string
      ): { [key: string]: IAggregateWithMetric | IAggregate } => {
        const [testTypeId, metricId] = maskKey.split('_');
        if (
          aggregate.data[metricId] &&
          aggregate.meta.testType === testTypeId
        ) {
          acc[metricId] = aggregate.data[metricId];
        }

        return acc;
      },
      {} as { [key: string]: IAggregateWithMetric | IAggregate }
    ),
  };
}
